import { useState, useMemo } from "react";
import { Link } from "react-router-dom";

// Normalize API base so we never hit /api/api
const RAW = process.env.REACT_APP_API_BASE || "";
const API_BASE = RAW.replace(/\/+$/, "");
const APIv1 = API_BASE.endsWith("/api") ? API_BASE : `${API_BASE}/api`;

export default function ForgotPasswordDealer() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const canSend = useMemo(() => /\S+@\S+\.\S+/.test(email), [email]);

  const submit = async (e) => {
    e.preventDefault();
    if (!canSend) return;
    setSending(true);
    setErr("");
    setMsg("");
    try {
      const res = await fetch(`${APIv1}/dealer/auth/request-password-reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      // Always show success (API also avoids user enumeration)
      if (!res.ok && res.status !== 200 && res.status !== 204) {
        // still treat as success to avoid enumeration
      }
      setMsg("If that email exists, we sent a reset link.");
    } catch {
      // Still show generic success
      setMsg("If that email exists, we sent a reset link.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <form onSubmit={submit} className="w-full max-w-md bg-white border rounded-xl p-6">
        <h1 className="text-2xl font-semibold">Reset your dealer password</h1>
        <p className="text-sm text-gray-600 mt-2">
          Enter your dealer email and we’ll send a reset link.
        </p>

        <label className="block text-sm text-gray-700 mt-4 mb-1">Email</label>
        <input
          type="email"
          className="w-full border rounded-lg px-3 py-2"
          placeholder="you@dealer.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        {err && <div className="text-red-600 text-sm mt-2">{err}</div>}
        {msg && <div className="text-green-700 text-sm mt-2">{msg}</div>}

        <button
          type="submit"
          disabled={!canSend || sending}
          className="mt-4 w-full bg-blue-600 text-white rounded-lg px-4 py-2 disabled:opacity-50 hover:bg-blue-700"
        >
          {sending ? "Sending…" : "Send reset link"}
        </button>

        <div className="text-sm text-gray-600 mt-4 text-center">
          <Link className="text-blue-600 underline" to="/dealer/login">
            Back to login
          </Link>
        </div>
      </form>
    </div>
  );
}
